export let NotificationScenarios;
(function (NotificationScenarios) {
  NotificationScenarios["Connection"] = "connection";
  NotificationScenarios["DownloadTranscriptError"] = "download transcript";
  NotificationScenarios["EmailTranscriptError"] = "email transcript";
  NotificationScenarios["EmailAddressSaved"] = "email address saved";
  NotificationScenarios["AttachmentError"] = "attachment";
  NotificationScenarios["InternetConnection"] = "internet connection";
  NotificationScenarios["MaxSizeError"] = "max size";
  NotificationScenarios["ChatDisconnect"] = "chat disconnect";
  NotificationScenarios["TPC"] = "tpc blocked";
})(NotificationScenarios || (NotificationScenarios = {}));